
export const extractEmail = (text) => {
    
    let regexPattern = /(?=([a-z0-9._+-]+))\1@(?=([a-z]+))\2\.(?=([a-z]+))\3/gi;
    return text.match(regexPattern);
}
